import http from 'hub-http/clients/apiClient';

// @ts-expect-error Untyped module
import getEarlyRequesterResultPromise from '../earlyRequester/getEarlyRequesterResultPromise';
const URI = 'cms-user-settings';
export default {
  getUserSettings() {
    return getEarlyRequesterResultPromise({
      name: 'initial-cms-user-settings-fetch',
      retryRequester: () => http.get(URI)
    });
  }
};